<template>
  <video
    ref="video"
    loop
    muted
    preload="metadata"
    playsinline
    :src="src"
    v-on="$listeners"
  />
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true,
    },
    threshold: {
      type: Number,
      default: 0.5,
    },
  },
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    const video = this.$refs.video
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(error => {})
        } else {
          video.pause()
        }
      },
      {
        threshold: this.threshold, // Adjust this value as needed
      }
    )

    // Observe the video element
    this.observer.observe(video)
  },
  beforeDestroy() {
    try {
      if (this.observer) {
        this.observer.disconnect()
      }
      this.$refs.video.pause()
    } catch (error) {}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/AutoVideoPlayer.vue